const timezoneDiff = new Date().getTimezoneOffset() * 60 * 1000;

export default function adjustToTimeZone(dateObj) {
  if (!dateObj) return null;
  return new Date(dateObj.getTime() - timezoneDiff);
}
